import { PayoutOrderStatus, PayoutOrderStatusDetails, UserRole } from 'enums';
import { PayoutOrder } from 'types';

export enum PayoutManualBatchOperation {
  Assign = 'assign',
  Cancel = 'cancel',
}

export enum PayoutManualBatchStatus {
  InProgress = 'in_progress',
  Completed = 'completed',
  /** Processing was interrupted (the backend pod died mid-batch) and a sweep closed the batch. */
  Error = 'error',
}

export enum PayoutManualBatchItemResult {
  /** Reserved by the batch, nothing sent yet. */
  Claimed = 'claimed',
  /** The provider request is on the wire. */
  InProgress = 'in_progress',
  Success = 'success',
  Failed = 'failed',
  Dispute = 'dispute',
  Skipped = 'skipped',
}

/** Mirrors the backend PayoutPlacementFailure codes used by the batch journal. */
export enum PayoutPlacementFailure {
  ProviderNotFound = 'payout_provider_not_found',
  ProviderDisabled = 'payout_provider_disabled',
  OrderNotSupported = 'payout_order_not_supported',
  TradeMethodNotSupported = 'payout_trade_method_not_supported',
  RejectedByProvider = 'payout_rejected_by_provider',
  EmptyProviderResponse = 'payout_empty_provider_response',
  UnresolvedResponse = 'payout_unresolved_response',
  RequestFailed = 'payout_request_failed',
}

export enum PayoutManualSkipReason {
  Locked = 'order_locked',
  NotInQueue = 'order_not_in_queue',
  Interrupted = 'batch_interrupted',
}

/** Results an item can no longer move away from — mirrors MANUAL_BATCH_TERMINAL_RESULTS. */
export const MANUAL_BATCH_TERMINAL_RESULTS = [
  PayoutManualBatchItemResult.Success,
  PayoutManualBatchItemResult.Failed,
  PayoutManualBatchItemResult.Dispute,
  PayoutManualBatchItemResult.Skipped,
];

export type PayoutManualBatchItem = {
  id: string;
  orderId: string;
  result: PayoutManualBatchItemResult;
  previousStatus: PayoutOrderStatus;
  previousStatusDetails?: PayoutOrderStatusDetails;
  resultStatus?: PayoutOrderStatus;
  resultStatusDetails?: PayoutOrderStatusDetails;
  failure?: PayoutPlacementFailure;
  skipReason?: PayoutManualSkipReason;
  failureReason?: string;
  providerRequestId?: string;
  providerExternalOrderId?: string;
  createdAt: string;
  order?: PayoutOrder;
};

export type PayoutManualBatch = {
  id: string;
  operation: PayoutManualBatchOperation;
  status: PayoutManualBatchStatus;
  createdAt: string;
  userId: string;
  user?: { id: string; name: string; role: UserRole };
  p2pProviderId?: string;
  p2pProvider?: { id: string; name: string };
  totalCount: number;
  successCount: number;
  failedCount: number;
  disputeCount: number;
  skippedCount: number;
  items?: PayoutManualBatchItem[];
};
